import React, { Fragment, useState, useEffect, useRef } from "react";
import style from '../styles/barralateral.module.scss';
import stylegeneral from '../styles/general.module.scss';
import styleBtn from '../styles/btn.module.scss';
import { Link, useLocation } from "react-router-dom";
import { Icon } from '@iconify/react';
import PictureComponent from "./PictureComponent";
import { DatosUrlSeccion } from "../api/DatosUrlSeccion";
import { scrollToTop } from "./GlobalFunction";
import { Logout } from "../api/Autenticacion";
import { useAuth } from "../context/AuthContext";
import { RUTA_LOGIN } from "../constants/rutas";

const BarraLateralComponent = (props) => {
  const { setControlMenu, menuFijado, onToggleFijar } = props;
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location.pathname);
  const [seccionActual, setSeccionActual] = useState(1);
  const [Url, setUrl] = useState('/home');
  const currentSearch = location.search;
  const selectRef = useRef();
  const { setIsAdmin, isAdmin, isSuper, nombreUsuario } = useAuth();


  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location.pathname])

  // capturamos la url actual
  useEffect(() => {
    DatosUrlSeccion.forEach(view => {
      // separamos la url configurada en partes (base + query)
      const [baseUrl, queryString] = view.url.split('?');
      let seccionNota = 13;
      // caso 1: si coincide el pathname
      if (baseUrl === currentPath) {
        // si no tiene query en la config o coincide con el actual
        if (!queryString || `?${queryString}` === currentSearch) {
          setSeccionActual(view.seccion);
          seccionNota = view.seccion;
          setUrl(view.url);
        }
      } else {
        // caso 2: capturamos la url sin id (por ejemplo "/notas/123" => "/notas")
        const partesUrlNavegador = currentPath.split('/');
        const urlNavegadorBase = partesUrlNavegador.slice(0, partesUrlNavegador.length - 1).join('/');

        if (view.url === urlNavegadorBase) {
          setSeccionActual(view.seccion);
        } else if ('/detalle-notas' === urlNavegadorBase) {
          setSeccionActual(seccionNota);
        }
      }
    });
  }, [currentPath, currentSearch]);

  const odternerId = () => {
    scrollToTop();
    setControlMenu(false);
  }

  const logout = () => {
    Logout();
    window.location.href = RUTA_LOGIN
    setIsAdmin(false);
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setControlMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Fragment>

      <div ref={selectRef} className={`${stylegeneral.fondo_img} ${stylegeneral.login_fondo} p-3 d-flex flex-column`}>
        <div className={`d-flex align-items-center justify-content-between mb-5 ${style.usuarioActual}`}>
          <div className={`d-flex align-items-center text-truncate ${style.usuarioInfo}`}>
            <Icon icon="mdi:account-circle" className={`color-white me-2 ${style.usuarioIcono}`} />
            {nombreUsuario && (
              <span className={`color-white fw700 WorkSans text-truncate sidebar-text ${style.usuarioNombre}`}>{nombreUsuario}</span>
            )}
          </div>

          {/* Mismo lugar donde antes vivía el carrito (ahora es un botón
              flotante solo en Home, ver HomePage.jsx). Fija/desfija el menú:
              fijado lo deja siempre expandido; sin fijar, se expande solo al
              pasar el cursor. */}
          <button
            type="button"
            onClick={onToggleFijar}
            title={menuFijado ? 'Desfijar menú' : 'Fijar menú siempre visible'}
            className={`${styleBtn.btn_desnudo} color-white ${style.pinBtn}`}
          >
            <Icon icon={menuFijado ? 'mdi:pin' : 'mdi:pin-outline'} />
          </button>
        </div>

        <nav className={`${style.navbar}`}>
          <ul className="p-0 fw700">
            {DatosUrlSeccion
              //  Primero filtra solo los elementos principales
              .filter(item => item.principal)

              // Luego filtra según el rol del usuario
              .filter(item => {
                let userRole = "vendedor"; // por defecto
                if (isSuper) {
                  userRole = "super";
                } else if (isAdmin) {
                  userRole = "admin";
                }
                // Si el item no tiene roles definidos, no se mostrará
                return item.roles?.includes(userRole);
              })
              .map((item, index) => {
                return (
                  <li key={index} className={`${(seccionActual === item.seccion) ? style.active : ''} WorkSans mb-3`} onClick={odternerId}>
                    <Link to={item.url}>
                      <Icon icon={item.icon || 'mdi:circle-small'} />
                      <span className="sidebar-text">{item.name}</span>
                    </Link>
                  </li>
                )
              })}
          </ul>
        </nav>
        <div className={`fixclase d-flex align-items-center ${isAdmin ? 'justify-content-between' : 'justify-content-center'}`}>
          {isAdmin && (
            <Link to={'/configuracion'} onClick={odternerId}>
              <PictureComponent src="/img/config.png" alt="logo" styleGroup={`w-auto ${styleBtn.btnLink_img}`} />
            </Link>
          )}

          <button type="button" onClick={logout} className={`WorkSans ${styleBtn.btn_desnudo}  ${styleBtn.text} color-white fw700 d-flex  justify-content-center align-items-center`}><Icon icon="hugeicons:logout-04" /> <span className="mb-0 ms-2 sidebar-text">Cerrar sesion</span></button>
        </div>
      </div>
    </Fragment>
  )
}

export default BarraLateralComponent;